import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import * as S from './styled';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = ({ file }) => {
  const [totalPages, setTotalPages] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }) => setTotalPages(numPages);

  const pages = useMemo(() => {
    if (!totalPages) return null;

    return Array.from({ length: totalPages }, (_, i) => (
      <Page key={i + 1} pageNumber={i + 1} width={600} scale={1.3} renderAnnotationLayer renderTextLayer />
    ));
  }, [totalPages]);

  if (!file?.url) return null;

  return (
    <S.PdfContainer>
      <Document file={file.url} externalLinkTarget="_blank" onLoadSuccess={onDocumentLoadSuccess}>
        {pages}
      </Document>
    </S.PdfContainer>
  );
};

PdfViewer.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string
  }).isRequired
};

export default PdfViewer;
